import * as React from 'react';
import { Modal } from 'antd';
import { IWidget } from 'common/schema/widget/Widget';
import { FormWidgetSwitch } from '../switch/FormWidgetSwitch';
import { FormikForm } from 'client/ui/form/FormikForm';
import { getWidgetInputLayout } from '../../helper/getWidgetInputLayout';
import { Formik } from 'formik';
import { useCallback, useMemo } from 'react';
import { IRequestListRow } from 'common/schema/request/Request';
import { useWidgetListCompile } from './useWidgetListCompile';
import { schemaToValidator } from 'client/core/validation/schemaToValidator';
import {
  createProcedureValuesValidator,
  createWidgetListRowValidator
} from 'common/schema/request/createProcedureValuesValidator';

export interface FormNestedWidgetModalProps {
  widget: IWidget;
  row: IRequestListRow | undefined;
  onClose: () => void;
}

export function FormNestedWidgetModal(props: FormNestedWidgetModalProps) {
  const { widget, row } = props;
  const list = useWidgetListCompile(widget);

  const handleCancel = useCallback(() => {
    if (row?.isPlaceholder) {
      list.removeRow(row);
    }
    props.onClose();
  }, [list, props.onClose]);

  const subwidgets = widget.input?.subwidgets ?? [];

  const layout = getWidgetInputLayout();

  const validator = useMemo(() => createWidgetListRowValidator(subwidgets), [
    subwidgets
  ]);

  return (
    <Formik<IRequestListRow>
      enableReinitialize
      initialValues={row ?? ({} as any)}
      validate={schemaToValidator(validator)}
      onSubmit={values => {
        // Segniamo la riga come valida
        delete values.isPlaceholder;
        // console.log('values', values);

        list.updateRow(row!, values);
        props.onClose();
      }}
    >
      {nestedFormik => (
        <Modal
          style={{ top: '60px' }}
          title={widget.input?.label}
          visible={row != null}
          width={700}
          okText={row?.isPlaceholder ? 'Aggiungi' : 'Modifica'}
          onOk={nestedFormik.submitForm}
          onCancel={handleCancel}
          zIndex={1001}
        >
          {row && (
            <div>
              <FormikForm {...layout} layout="horizontal">
                {subwidgets.map((widget, key) => (
                  <FormWidgetSwitch key={key} widget={widget} />
                ))}
              </FormikForm>
            </div>
          )}
        </Modal>
      )}
    </Formik>
  );
}
